var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "32px",
    viewBox: "0 0 28 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.8995197%",
    y1: "99.2910367%",
    x2: "49.8995197%",
    y2: "2.828402%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD0049",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0049",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Closed-Beta",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47823648,0 C1.55731778,0 -2.04281037e-13,1.5579505 -2.04281037e-13,3.47964963 L-2.04281037e-13,22.2348598 C-2.04281037e-13,24.1567037 1.55731778,25.7145094 3.47823648,25.7145094 L8.37092685,25.7145094 C8.88564216,25.7145094 9.37097412,25.9541607 9.68405882,26.3630883 L12.20379,29.6542026 C12.5581272,30.1171423 13.2556562,30.1148254 13.6070985,29.6498585 L16.0838403,26.371487 C16.396346,25.9577808 16.8848623,25.7145094 17.403341,25.7145094 L22.225685,25.7145094 C24.1466037,25.7145094 25.7039215,24.1567037 25.7039215,22.2348598 L25.7039215,3.47964963 C25.7039215,1.5579505 24.1466037,0 22.225685,0 L3.47823648,0 Z",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93883438,16.1488818 C9.96604609,15.1108221 9.64782025,14.0931759 9.034045,13.2551676 L8,11.843467 L9.50299348,11.3780412 C10.5492838,11.0539972 11.4492355,10.3749112 12.0474396,9.45827348 L12.9987912,8 L13.9501429,9.45827348 C14.548347,10.3749112 15.4484499,11.0539972 16.494589,11.3780412 L17.9977336,11.843467 L16.9638398,13.2551676 C16.3499134,14.0931759 16.0316875,15.1108221 16.0587481,16.1488818 L16.1072756,18 L14.6438903,17.4535255 C13.5829359,17.0572029 12.4146465,17.0572029 11.3538433,17.4535255 L9.89030683,18 L9.93883438,16.1488818 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerExplore);
export default __webpack_public_path__ + "static/media/MapMarkerExplore.2ff541a3.svg";
export { ForwardRef as ReactComponent };